import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import centralApiAxios from "../../axios/centralApiAxios";
import { GET_INVOICE, GET_INVOICE_LINEITEMS, GET_INVOICE_BILLINGCONTACT } from "../actions";
import {
  getInvoiceSuccess,
  getInvoiceError,
  getRecordsSuccess,
  getRecordsError,
  getInvoiceBillingContactSuccess,
  getInvoiceBillingContactError
} from "./actions";
import { getActivityHeadersUpdated } from "../../utils/parentChildActivities";
// eslint-disable-next-line
const getRecordListAsync = async (payload) => {
  const sendDate = new Date().getTime();
  let receiveDate = new Date().getTime();
  // eslint-disable-next-line
  const pageSize = 20;

  let recordAccountListReturned = []
  recordAccountListReturned.data = [];
  recordAccountListReturned.data.items = [];

  let item3 = [];
  item3.line_item_id = "4";
  item3.invoiceId = 4;
  item3.quantity = 1;
  item3.name = "Students in Psychology";
  item3.cost_per_unit = "11";
  item3.line_total = 11;
  recordAccountListReturned.data.items.push(item3);

  let item2 = [];
  item2.line_item_id = "5";
  item3.invoiceId = 4;
  item2.quantity = 2;
  item2.name = "Membership";
  item2.cost_per_unit = "10";
  item2.line_total = 20;
  recordAccountListReturned.data.items.push(item2);

  //search by invoiceid
  //const recordRemittanceListReturned = await axios.get("vocabularies?trashed=false&search_text=" + remittanceSearchText + "&page_number=" + payload.pageNumber);

  return {
    recordList: recordAccountListReturned,
    total_item_count: recordAccountListReturned.data.total_item_count,
    message: null,
    responseTime: ((receiveDate - sendDate) / 1000).toFixed(1),
  };
};

function* getRecordList({ payload }) {
  try {
    const pageSize = 20;
    const recordListReturned = yield call(getRecordListAsync, payload);
    if (!recordListReturned.message) {
      const recordListParam = {
        records: recordListReturned.recordList,
        pagination: {
          pageNumber: payload.pageNumber,
          pageSize,
          startIndex: (payload.pageNumber - 1) * pageSize + 1,
          totalItemCount: recordListReturned.total_item_count,
          totalPages: Math.ceil(recordListReturned.total_item_count / pageSize),
        },
        responseTime: recordListReturned.responseTime,
      };
      if (payload.searchInputName) {
        recordListParam.searchInputName = recordListReturned.recordList;
      }
      yield put(getRecordsSuccess(recordListParam));
    } else {
      yield put(getRecordsError(recordListReturned.message));
    }
  } catch (error) {
    yield put(getRecordsError(error));
  }
}

const getInvoiceAsync = async (payload) => {
  try {

    const recordInvoiceGetReturned = await centralApiAxios.get('invoices/summary/' + payload.invoiceId, getActivityHeadersUpdated(payload));
    if (recordInvoiceGetReturned.data) {
      return {
        invoice: recordInvoiceGetReturned.data,
        message: null,
      };
    }

    return { message: "Get process failed." };

  } catch (error) {
    return {
      message: "Failed to get process. ",
    };
  }
};

function* getInvoice({ payload }) {
  try {
    const returnedData = yield call(getInvoiceAsync, payload, getActivityHeadersUpdated(payload));
    if (!returnedData.message) {
      yield put(
        getInvoiceSuccess({
          invoice: returnedData.invoice,
        })
      );
    } else {
      yield put(getInvoiceError(returnedData.message));
    }
  } catch (error) {
    yield put(getInvoiceError(error));
  }
}


const getInvoiceBillingContactAsync = async (payload) => {
  try {
    if (payload.billingContactId == 0) {
      return { message: "Get user info failed." };
    }

    if (payload.verbType == undefined) {
      payload.verbType = 2;
    }

    const contactReturned = await centralApiAxios.get(
      `/Contacts/${payload.billingContactId}?verbType=${payload.verbType}`
    );

    if (contactReturned.data) {
      return {
        contact: contactReturned.data,
        contactTypes: [],
        contactActivities: [],
        message: null,
      };
    }
    return { message: "Get user info failed." };
  } catch (error) {
    return {
      message: "Failed to get contact. ",
    };
  }
};


function* getInvoiceBillingContact({ payload }) {
  try {
    const returnedData = yield call(getInvoiceBillingContactAsync, payload);
    if (!returnedData.message) {
      yield put(
        getInvoiceBillingContactSuccess({
          contact: returnedData.contact,
          contactTypes: returnedData.contactTypes,
          contactActivities: returnedData.contactActivities,
        })
      );
    } else {
      yield put(getInvoiceBillingContactError(returnedData.message));
    }
  } catch (error) {
    yield put(getInvoiceBillingContactError(error));
  }
}


export function* watchGetInvoiceBillingContact() {
  yield takeEvery(GET_INVOICE_BILLINGCONTACT, getInvoiceBillingContact);
}

export function* watchGetRecords() {
  yield takeEvery(GET_INVOICE_LINEITEMS, getRecordList);
}

export function* watchGetInvoice() {
  yield takeEvery(GET_INVOICE, getInvoice);
}

export default function* rootSaga() {
  yield all([
    fork(watchGetInvoice),
    fork(watchGetRecords),
    fork(watchGetInvoiceBillingContact),
  ]);
}
